// ========== 环境切换配置 ==========
// Vue CLI 会自动注入 process.env.NODE_ENV (开发: development, 生产: production)
// 开发环境运行: npm run serve (NODE_ENV=development)
// 生产环境构建: npm run build (NODE_ENV=production)
const ENVIRONMENT = process.env.NODE_ENV || 'development'  // <-- 默认开发环境
// ====================================

import devConfig from './env.development'
import prodConfig from './env.production'

const config = ENVIRONMENT === 'production' ? prodConfig : devConfig

console.log(`✓ 当前环境: ${config.env} | API: ${config.baseURL}`)

export default config

